<template>
    <svg width="88" height="88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 44c0 24.3 19.7 44 44 44s44-19.7 44-44S68.3 0 44 0 0 19.7 0 44z" fill="#EDF4FC" />
        <path
            d="M20.705 27.607h46.589c1.725 0 2.588.855 2.588 2.564v28.52c0 1.709-.863 2.563-2.588 2.563H20.705c-1.725 0-2.588-.854-2.588-2.563V30.17c0-1.71.863-2.564 2.588-2.564z"
            fill="#1976D2" />
        <path
            d="M20.705 61.255h46.589c1.43 0 2.588-1.12 2.588-2.501V54.22C56.048 43.38 47.42 37.96 43.999 37.96c-3.42 0-12.048 5.42-25.882 16.26v4.534c0 1.381 1.159 2.501 2.588 2.501z"
            fill="#04BEFE" />
        <path
            d="M20.705 26.744h46.589a2.585 2.585 0 012.588 2.582v4.68C55.27 44.12 46.643 49.176 43.999 49.176c-2.643 0-11.27-5.057-25.882-15.17v-4.68a2.585 2.585 0 012.588-2.582z"
            fill="#DDEBF8" />
    </svg>
</template>
